import React, { useEffect, useState } from 'react';
import * as ReactDOM from 'react-dom';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import {
  Button, Col, Icons, Row,
} from '../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  formatRegistryNumber, infoFormatter,
  infoFormatterIntl, statusFormatter,
} from '../../../utils/formatters';
import { useUpdatePeriod } from '../../../utils/utils';
import ApplicationLegend from './ApplicationLegend';
import {
  APPLICATION_STATUS,
  PROCEDURE_CARRIER_TYPES,
  PROCEDURE_SZLT_TYPES,
  PROCEDURE_TYPE,
  PROCEDURE_VEHICLE_TYPES,
  REGISTRY_TYPE,
} from '../../../configs';
import { getApplicationData } from '../reducer';
import ApplicationInfoView from './ViewBlocks/ApplicationInfoView';
import ApplicantView from './ViewBlocks/ApplicantView';
import RepresentativeView from './ViewBlocks/RepresentativeView';
import ApplicationCarrierView from './ViewBlocks/ApplicationCarrierView';
import ApplicationSzltView from './ViewBlocks/ApplicationSzltView';
import ApplicationVehicleView from './ViewBlocks/ApplicationVehicleView';
import Loader from '../../../components/base/Loader/Loader';
import FileView from '../../../components/fields/FileInput/FileView';
import DocumentList from './DocumentList';
import AccordionWithPreview from '../../../components/base/Accordion/AccordionWithPreview';
import { errorNotification } from '../../Notifications/notificationDecorator';
import ExportInterface from '../../System/components/ExportInterface';
import TooltipWithPortal from '../../../components/base/Tooltip/TooltipWithPortal';
import ApplicationHistory from './ApplicationHistory';
import Switches from '../../../components/fields/Switches/Switches';
import ReorganizationJuridicalView from './ViewBlocks/NewValue/ReorganizationJuridicalView';
import ServiceMarkView from './ViewBlocks/NewValue/ServiceMarkView';
import FIOView from './ViewBlocks/NewValue/FIOView';
import AddressView from './ViewBlocks/NewValue/AddressView';
import OgrnView from './ViewBlocks/NewValue/OgrnView';
import OgrnipView from './ViewBlocks/NewValue/OgrnipView';
import DriverLicenseView from './ViewBlocks/NewValue/DriverLicenseView';
import VehicleRegistryBasisView from './ViewBlocks/NewValue/VehicleRegistryBasisView';
import VehicleCertificateView from './ViewBlocks/NewValue/VehicleCertificateView';
import ContractView from './ViewBlocks/NewValue/ContractView';
import SPBView from './ViewBlocks/NewValue/SPBView';
import NewSZLTView from './ViewBlocks/NewValue/NewSZLTView';
import ApplicationCarrierSzltView from './ViewBlocks/ApplicationCarrierSzltView';

export default function ApplicationView(props) {
  const { formatMessage } = useIntl();
  const {
    onClose = () => {},
    loadApplication = () => {},
    loadData = () => {},
    handleSign = () => {},
    handleEdit = () => {},
    isAssign = false,
    title = '',
    titleFull = '',
  } = props;
  const [showHistoryDialog, setShowHistoryDialog] = useState(false);
  const [showExport, setShowExport] = useState(false);
  const {
    currentApplication = { applicant: {} },
    loadingSmevCheckApplication,
    loadingCurrentApplication,
    fieldsValidation,
    loadingFieldsValidation,
  } = useSelector(getApplicationData);

  const {
    applicant = {},
    representative,
    procedure,
    application_order_service,
    application_carrier = {},
    application_vehicle,
    files = [],
    documents = [],
    status,
    rejection_reasons,
    rejection_reason_messages,
    numbers = [],
    registry_subjects = [],
    registry_subject = [],
    registry_subject_type = '',
  } = currentApplication;
  let registryType = REGISTRY_TYPE.CARRIER;
  if (registry_subject_type === 'vehicle') {
    registryType = REGISTRY_TYPE.VEHICLE;
  }
  if (registry_subject_type === 'order_service') {
    registryType = REGISTRY_TYPE.ORDER_SERVICE;
  }
  const [setPeriod, destroy, clear, load, createTimer] = useUpdatePeriod(() => { loadApplication(currentApplication.id); }, 30, true);
  useEffect(() => {
    createTimer();
    return destroy;
  }, []);

  const errorsProcedure = fieldsValidation?.errors?.procedure;

  useEffect(() => {
    if (errorsProcedure && Array.isArray(errorsProcedure) && errorsProcedure.length > 0) {
      errorNotification('Ошибка валидации', errorsProcedure.join(','));
    }
  }, [errorsProcedure]);

  const isVehicle = PROCEDURE_VEHICLE_TYPES.includes(procedure);
  const isSzlt = PROCEDURE_SZLT_TYPES.includes(procedure);
  const isCarrier = PROCEDURE_CARRIER_TYPES.includes(procedure);

  return ReactDOM.createPortal(
    <div className="application-form">
      <Loader loading={loadingSmevCheckApplication || loadingCurrentApplication || loadingFieldsValidation} />
      <div className="application-form-header">
        <div className="breadcrumbs">
          <span className="breadcrumbs-prev">Обращения</span>
          <Icons width={22} height={22} customIcon icon="arrow-right" className="breadcrumbs-arrow" />
          {title
            ? (
              <>
                <span className="breadcrumbs-prev">{title}</span>
                <Icons width={22} height={22} customIcon icon="arrow-right" className="breadcrumbs-arrow" />
              </>
            ) : null}
          {titleFull && titleFull !== title
            ? (
              <>
                <span className="breadcrumbs-prev">{titleFull}</span>
                <Icons width={22} height={22} customIcon icon="arrow-right" className="breadcrumbs-arrow" />
              </>
            ) : null}
          <span className="breadcrumbs-prev">{formatMessage({
            id: `procedure.type.${procedure}`,
            defaultMessage: ' ',
          })}
          </span>
          <Icons width={22} height={22} customIcon icon="arrow-right" className="breadcrumbs-arrow" />
          <span className="breadcrumbs-current">Обращение № {currentApplication?.mais_egu_id || 'Без номера'}</span>
          <span className="breadcrumbs-current"> ({!isAssign ? 'просмотр' : 'обработка'}) </span>
        </div>
        <div className="legend-button">
          <Icons width={24} height={24} customIcon icon="helper" />
          <ApplicationLegend />
        </div>
        <div className="delimiter" />
        <div className="close-button" onClick={onClose}>
          <Icons width={24} height={24} customIcon icon="close" />
        </div>
      </div>
      <div className="application-form-body application-form-view">
        <div className="application-form-body-wrapper">
          <div className="application-form-content">
            <div className="application-form-fields">
              <div className="application-form-fields-wrapper custom-scroll-theme">
                <div className="afc-header">
                  <div className="application-number">Обращение № {currentApplication.mais_egu_id || 'Без номера'}</div>
                  {currentApplication.status ? statusFormatter(currentApplication.status) : null}
                  <div className="application-options ms-lg-auto">
                    <TooltipWithPortal
                      content={<Icons customIcon icon="more-vert" className="more-vert" />}
                      classNamePortal="more-actions application-options-dropdown"
                      tooltipContent={(
                        <div className="more-wrapper">
                          <Button
                            variant="link"
                            className="w-100 more-button"
                            onClick={() => setShowExport(true)}
                          >
                            Экспорт обращения
                          </Button>
                          <Button
                            variant="link"
                            className="w-100 more-button"
                            onClick={() => window.open(`/application/history?subject_id=${currentApplication.id}`, '_blank')}
                          >
                            История изменений
                          </Button>
                          {/* <Button */}
                          {/*  variant="link" */}
                          {/*  className="w-100 more-button" */}
                          {/*  onClick={() => window.open(`/application/mais-history?maisEguNumber=${currentApplication?.mais_egu_id}&procedure=${procedure}`, '_blank')} */}
                          {/* > */}
                          {/*  МАИС ЭГУ */}
                          {/* </Button> */}
                        </div>
                      )}
                      classNameWrapper="more-tooltip-wrapper"
                      className="more-tooltip"
                    />
                    {showExport ? (
                      <ExportInterface
                        customControl
                        selected={[currentApplication.id]}
                        className="w-100 more-button"
                        variant="link"
                        buttonText="Экспорт обращения"
                        page="applications"
                        exporter="applications"
                      />
                    ) : null}
                  </div>
                  {showHistoryDialog ? (
                    <ApplicationHistory
                      currentApplication={currentApplication}
                      close={() => setShowHistoryDialog(false)}
                    />
                  ) : null}
                </div>
                <div className="afc-body">
                  <div className="afc-main">
                    <AccordionWithPreview
                      title="Информация об обращении"
                      component={ApplicationInfoView}
                      componentProps={{
                        fieldsValidation,
                        currentApplication,
                      }}
                    />
                    <AccordionWithPreview
                      title="Получатель услуги"
                      component={ApplicantView}
                      componentProps={{
                        fieldsValidation,
                        className: 'mt-3',
                        applicant,
                        currentApplication,
                      }}
                    />
                    <Row className="row-cols-1">
                      <Col>
                        <Switches
                          type="text"
                          variant="material"
                          inputProps={{
                            onChange: () => {},
                            value: representative,
                          }}
                          label="Представитель"
                        />
                      </Col>
                    </Row>
                    {representative ? (
                      <AccordionWithPreview
                        title="Представитель"
                        component={RepresentativeView}
                        componentProps={{
                          fieldsValidation,
                          representative,
                          currentApplication,
                        }}
                      />
                    ) : null}
                  </div>
                  <div className="afc-registry">
                    {isCarrier ? (
                      <ApplicationCarrierView
                        key="application-carrier-view"
                        fieldsValidation={fieldsValidation}
                        currentApplication={currentApplication}
                        data={application_carrier || {}}
                      />
                    ) : null}
                    {isSzlt ? (
                      <ApplicationSzltView
                        fieldsValidation={fieldsValidation}
                        currentApplication={currentApplication}
                        data={application_order_service || {}}
                      />
                    ) : null}
                    {isVehicle ? (
                      <ApplicationVehicleView
                        fieldsValidation={fieldsValidation}
                        currentApplication={currentApplication}
                        data={application_vehicle || {}}
                      />
                    ) : null}
                    <ReorganizationJuridicalView applicantType={applicant?.legal_entity_type} procedure={procedure} currentApplication={currentApplication} />
                    <ServiceMarkView applicantType={applicant?.legal_entity_type} procedure={procedure} currentApplication={currentApplication} />
                    <FIOView applicantType={applicant?.legal_entity_type} procedure={procedure} currentApplication={currentApplication} />
                    <AddressView applicantType={applicant?.legal_entity_type} procedure={procedure} currentApplication={currentApplication} />
                    <OgrnView applicantType={applicant?.legal_entity_type} procedure={procedure} currentApplication={currentApplication} />
                    <OgrnipView applicantType={applicant?.legal_entity_type} procedure={procedure} currentApplication={currentApplication} />
                    <DriverLicenseView applicantType={applicant?.legal_entity_type} procedure={procedure} currentApplication={currentApplication} />
                    <VehicleRegistryBasisView applicantType={applicant?.legal_entity_type} procedure={procedure} currentApplication={currentApplication} />
                    <VehicleCertificateView applicantType={applicant?.legal_entity_type} procedure={procedure} currentApplication={currentApplication} />
                    <ContractView applicantType={applicant?.legal_entity_type} procedure={procedure} currentApplication={currentApplication} />
                    <SPBView applicantType={applicant?.legal_entity_type} procedure={procedure} currentApplication={currentApplication} />
                    <NewSZLTView applicantType={applicant?.legal_entity_type} procedure={procedure} currentApplication={currentApplication} />
                    {isCarrier ? (
                      <ApplicationCarrierSzltView
                        key="application-carrier-view"
                        fieldsValidation={fieldsValidation}
                        currentApplication={currentApplication}
                        data={application_carrier || {}}
                      />
                    ) : null}
                    <FileView files={files} />
                    <div className="hr-row mt-3" />
                    <AccordionWithPreview
                      title="Итоговое решение"
                      content={(
                        <DocumentList
                          documents={documents}
                          id={currentApplication?.id}
                          loadData={() => {
                            loadApplication();
                            loadData();
                          }}
                        />
                      )}
                    />
                    {numbers?.length && [PROCEDURE_TYPE.PROCEDURE_1227_1, PROCEDURE_TYPE.PROCEDURE_1227_6, PROCEDURE_TYPE.PROCEDURE_1228_1].includes(procedure) ? (
                      <div>
                        <div className="f4 mt-3">Результаты рассмотрения обращения</div>
                        <div className="mt-3">
                          {formatRegistryNumber(numbers, registry_subjects, registry_subject, registryType, null, 'carrier')}
                        </div>
                      </div>
                    ) : null}
                    <Row className="row-cols-1">
                      {infoFormatterIntl('application.comment', currentApplication?.comment)}
                    </Row>
                    {rejection_reasons && [APPLICATION_STATUS.SUSPENDED, APPLICATION_STATUS.RETURN, APPLICATION_STATUS.DENIED].includes(currentApplication.status) ? (
                      <>
                        <div className="f4 mt-3">{formatMessage({ id: `rejection.reason.header.${currentApplication.status}`, defaultMessage: 'Причины статуса' })}</div>
                        <Row className="row-cols-1">
                          {infoFormatter('Основания', rejection_reason_messages?.map(e => e.name).join(', ') || '')}
                        </Row>
                        <Row className="row-cols-1">
                          {infoFormatter('Дополнительное основание', rejection_reason_messages?.[0]?.additional_message || '')}
                        </Row>
                        <Row className="row-cols-1">
                          {infoFormatter('Комментарий', rejection_reason_messages?.[0]?.message || '')}
                        </Row>
                      </>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
            <div className="application-form-footer">
              {(status === APPLICATION_STATUS.SIGN_PENDING) ? (
                <Button variant="secondary" onClick={handleEdit(currentApplication)}>Редактировать</Button>
              ) : null}
              <Button variant="secondary" className="ms-lg-auto">Отозвать заявление</Button>
              <Button
                disabled={currentApplication.status !== APPLICATION_STATUS.SIGN_PENDING && currentApplication.status !== APPLICATION_STATUS.SIGN_FAILED}
                onClick={() => {
                  handleSign(currentApplication);
                }}
              >Подписать заявление
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>,
    document.getElementById('app-content'),
  );
}
